(() => {
  if (window.__velvetPdpBuyingReady) return;
  window.__velvetPdpBuyingReady = true;

  const refreshBar = (bar) => {
    const productInfo = bar.closest('product-info');
    if (!productInfo) return;

    const mainButtonId = bar.querySelector('[data-vc-mobile-add]')?.dataset.mainSubmit;
    const mainButton = mainButtonId ? document.getElementById(mainButtonId) : null;
    const mobileButton = bar.querySelector('[data-vc-mobile-add]');
    const variantLabel = bar.querySelector('[data-vc-mobile-variant]');
    const mobilePrice = bar.querySelector('.vc-mobile-buy-bar__summary strong');
    const priceContainer = productInfo.querySelector('[id^="price-"]');
    const priceElement = priceContainer?.querySelector('.price--on-sale .price-item--sale')
      || priceContainer?.querySelector('.price:not(.price--on-sale) .price-item--regular')
      || priceContainer?.querySelector('.price-item--sale')
      || priceContainer?.querySelector('.price-item--regular');
    const priceText = priceElement?.textContent.trim().replace(/\s+ZAR$/i, '');
    const selectedValues = [...new Set(
      [...productInfo.querySelectorAll('variant-selects input[type="radio"]:checked')]
        .map((input) => input.value)
        .filter(Boolean),
    )];

    if (variantLabel) variantLabel.textContent = selectedValues.join(' · ') || 'Ready to add';
    if (mobilePrice && priceText) mobilePrice.textContent = priceText;
    if (mobileButton && mainButton) {
      mobileButton.disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      mobileButton.textContent = mobileButton.disabled ? 'Sold out' : 'Add to cart';
      const mainButtonLabel = mainButton.querySelector('span');
      if (mainButtonLabel && !mobileButton.disabled && priceText) {
        mainButtonLabel.textContent = `Add to cart · ${priceText}`;
      }
    }
  };

  const initialise = () => {
    document.querySelectorAll('[data-vc-mobile-buy-bar]').forEach((bar) => {
      if (bar.dataset.vcReady === 'true') return;
      bar.dataset.vcReady = 'true';
      const mobileButton = bar.querySelector('[data-vc-mobile-add]');
      const productInfo = bar.closest('product-info');

      mobileButton?.addEventListener('click', () => {
        const target = document.getElementById(mobileButton.dataset.mainSubmit);
        if (target && !target.disabled && target.getAttribute('aria-disabled') !== 'true') target.click();
      });

      productInfo?.addEventListener('change', () => window.setTimeout(() => refreshBar(bar), 180));
      refreshBar(bar);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise);
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
